import { coerceSnowflakeString } from './dialogue.js'

export function normalizeEcoUserProfile(user) {
  if (!user) return null

  const ecoCert = user.ecoCertificationVo || null

  // 供应商侧（供应链生态）当前用户通常带 supplierDto + supplierCertificationStatus/supplierCertificationId，
  // 但 ecoCertificationVo 为空；对话中心复用本适配器，需兼容供应商的认证信息结构。
  const supplierDto = user.supplierDto || null
  const supplierCertLike =
    (supplierDto && (supplierDto.supplierCertificationVo || supplierDto.certificationVo || supplierDto.certification)) ||
    null

  const supplierCertificationId =
    user.supplierCertificationId ||
    (supplierDto && (supplierDto.supplierCertificationId || supplierDto.certificationId)) ||
    ''
  const supplierCertificationStatus =
    user.supplierCertificationStatus ||
    (supplierDto && supplierDto.supplierCertificationStatus) ||
    ''

  const certification =
    ecoCert ||
    supplierCertLike ||
    (supplierDto || supplierCertificationId || supplierCertificationStatus
      ? {
          id: supplierCertificationId || (supplierDto && supplierDto.id) || '',
          name: (supplierDto && supplierDto.name) || user.companyName || '',
          status: supplierCertificationStatus || ''
        }
      : null)

  const companyName =
    (certification && certification.name) ||
    (supplierDto && supplierDto.name) ||
    user.companyName ||
    '未认证服务商'

  return {
    userId: coerceSnowflakeString(user.id != null ? user.id : user.userId),
    companyId: user.companyId || '',
    companyName,
    avatarText: companyName ? companyName.slice(0, 1) : '未',
    schemeCertificationStatus: user.schemeCertificationStatus || '',
    certificationStatus:
      certification
        ? certification.status || ''
        : (supplierCertificationStatus || ''),
    isCertified: !!(
      (certification && certification.id) ||
      supplierCertificationStatus === 'Completed' ||
      supplierCertificationId
    ),
    ecoCertification: certification,
    raw: user
  }
}
